export enum RequestListMode{
    Deal = 'deal',
    List = 'list',
    Penalty = 'penalty',
    Refund = 'refund',
    FreightPost = 'freight-post'
}